import React from "react";
import {
  MegaMenuPreviewItem,
  MegaMenuPreviewItemProps,
} from "../MegaMenuPreviewItem/MegaMenuPreviewItem";

export interface MegaMenuPreviewBlockProps {
  items: MegaMenuPreviewItemProps[];
}

export const MegaMenuPreviewBlock: React.FC<MegaMenuPreviewBlockProps> = (
  props
) => {
  return (
    <div className="grid-cols-1 md:grid-cols-3 grid gap-x-4 gap-y-14 mb-20 container pt-28 md:pt-0">
      {props.items.map((item) => (
        <MegaMenuPreviewItem {...item} />
      ))}
    </div>
  );
};
